/// DEPRECATED TYPES Start
// These types & constants are only in place for transition from old experiment wrapper to sdk
var QUERY_PARAM = 'QUERY_PARAM';
var VARIANT_A = 'variantA';
var VARIANT_B = 'variantB';
var VARIANT_C = 'variantC';
var VARIANT_D = 'variantD';
var VARIANT_E = 'variantE';
var VARIANT_F = 'variantF';
var VARIANT_G = 'variantG';
var VARIANT_H = 'variantH';
var VARIANT_I = 'variantI';
var VARIANT_J = 'variantJ';
var VARIANT_K = 'variantK';
var VARIANT_L = 'variantL';
var VARIANT_M = 'variantM';
var VARIANT_N = 'variantN';
var VARIANT_O = 'variantO';
var VARIANT_P = 'variantP';
var VARIANT_Q = 'variantQ';
var VARIANT_R = 'variantR';
var VARIANT_S = 'variantS';
var VARIANT_T = 'variantT';
var VARIANT_U = 'variantU';
var VARIANT_V = 'variantV';
var VARIANT_W = 'variantW';
var VARIANT_CONTROL = 'control';
var VARIANTS = [VARIANT_A, VARIANT_B, VARIANT_C, VARIANT_D, VARIANT_E, VARIANT_F, VARIANT_G, VARIANT_H, VARIANT_I, VARIANT_J, VARIANT_K, VARIANT_L, VARIANT_M, VARIANT_N, VARIANT_O, VARIANT_P, VARIANT_Q, VARIANT_R, VARIANT_S, VARIANT_T, VARIANT_U, VARIANT_V, VARIANT_W, VARIANT_CONTROL];
var NUMERIC_CONTROL = '0';
var ALL_NUMERICAL_VARIATIONS = [NUMERIC_CONTROL, '1', '2', '3', '4', '5', '6', '7', '8'];
var REASON_FORCED = 'FORCED';
var REASON_NO_EVALUATIONS = 'NO_EVALUATIONS';
var REASON_NOT_FOUND = 'NOT_FOUND';
var REASON_RULE_MATCH = 'RULE_MATCH';
var REASON_TARGET_MATCH = 'TARGET_MATCH';
var REASON_FALLTHROUGH = 'FALLTHROUGH';
var REASON_OFF = 'OFF';
var REASON_ERROR = 'ERROR';
var REASONS = [REASON_FORCED, REASON_NO_EVALUATIONS, REASON_NOT_FOUND, REASON_RULE_MATCH, REASON_TARGET_MATCH, REASON_FALLTHROUGH, REASON_OFF, REASON_ERROR];
// Known reasons returned from LD
// 'OFF': The flag was off and therefore returned its configured off value.
// 'FALLTHROUGH': The flag was on but the context did not match any targets or rules.
// 'TARGET_MATCH': The context key was specifically targeted for this flag.
// 'RULE_MATCH': the context matched one of the flag's rules.
// 'PREREQUISITE_FAILED': The flag was considered off because it had at least one prerequisite flag that either was off or did not return the desired variation.
// 'ERROR': The flag could not be evaluated, e.g. because it does not exist or due to an unexpected error.
var EVALUATION_NO_EVALUATIONS = {
  reason: REASON_NO_EVALUATIONS,
  variationId: 0
};
var EVALUATION_NOT_FOUND = {
  reason: REASON_NOT_FOUND,
  variationId: 0
};
var EVALUATION_FORCED = {
  reason: REASON_FORCED,
  variationId: 0
};
var HTJS_USER_ID = 'htjs_user_id';
var FORCE_EVALUATIONS_HEADER = 'x-experiments-force-evaluations';
var IS_EXPERIMENT_VISUALIZER_ON = 'isExperimentVisualizerOn';
var VISUALIZER_POSITION = 'visPosition';
var IS_VISUALIZER_HOVER_ON = 'isVisHoverOn';
var IS_VISUALIZER_TEXT_ON = 'isVisTextOn';
var ABSOLUTE = 'absolute';
var RELATIVE = 'relative';
var IS_VARIANT_REASON_ALWAYS_SHOWN = 'isVariantReasonAlwaysShown';
var ONLY_SHOW = 'onlyShow';
var SESSION_STORAGE_PREFIX = 'ExperimentVisualized-';
var LD_FLAG = 'LD Flag';
var YAML = 'Yaml';
var WEB_UI = 'Web UI';
var CODE_SEARCH = 'Code Search';
var YAML_URL = 'https://github.shuttercorp.net/data/experimentation/search?q=';
var WEB_UI_URL = 'https://experimentation-ui.shuttercorp.net/experimentation-analysis/?page=experiment_progress&experiment_id=';
var CODE_SEARCH_URL = 'https://shutterhound.shuttercorp.net/?q=';
var VARIANT_EXCLUDE = 'exclude';
var JIRA_TICKET_REG_EX = /^(([a-z]|[A-Z]))*[0-9]*-[0-9]+.*$/;
var PRODUCTION_VISUALIZER_ENABLE_KEY = '13f3bae94f4e4ffeab6e1741a9447423';
var PRODUCTION_VISUALIZER_ENABLE_VALUE = '24e04bfdd502465da8fd7dcd8330adb3';
var ALL = 'All';
var LOGGED_IN = 'Logged in';
var LOGGED_OUT = 'Logged out';
var LOGGED_IN_CHOICES = [ALL, LOGGED_IN, LOGGED_OUT];
var X_END_APP_NAME = 'x-end-app-name';
var X_END_APP_VERSION = 'x-end-app-version';
var X_END_USER_AGENT = 'x-end-user-ua';
var X_END_USER_ANONYMOUS_ID = 'x-end-user-anonymous-id';
var X_END_USER_COUNTRY = 'x-end-user-country';
var X_END_USER_LOCALE = 'x-end-user-request-locale';
var X_REQUEST_ID = 'x-request-id';
var X_END_USER_ID = 'x-end-user-id';
var X_CLIENT_ID = 'x-client-id';
var EXPERIMENT_VIEWED_EVENT = 'experimentViewed event: ';
var ERROR_BOUNDARY_LOG_MSG = 'An error occurred while rendering a feature in an experiment.';
var DEV = 'dev';
var DEVELOPMENT = 'development';
var PROD = 'prod';
var PRODUCTION = 'production';
var QA = 'qa';
var EXPERIMENTS_VIEWED_STASH_KEY = 'xprmntImpressions';
var EXPERIMENTS_VIEWED_USER_KEY = 'xUser';
var STASH_ITEMS_DELIMETER = '||';
var noop = function noop() {};
var stringReturnNoop = function stringReturnNoop() {
  return '';
};
var emptyObject = Object.freeze({});
var emptyArray = Object.freeze([]);
var BRAND_SHUTTERSTOCK = 'shutterstock';
var BRAND_POND_5 = 'pond-5';
var BRAND_PIC_MONKEY = 'picmonkey';
var BRAND_TURBO_SQUID = 'turbo-squid';

var BRANDS = [BRAND_SHUTTERSTOCK, BRAND_POND_5, BRAND_PIC_MONKEY, BRAND_TURBO_SQUID];

export { ABSOLUTE, ALL, ALL_NUMERICAL_VARIATIONS, BRANDS, BRAND_PIC_MONKEY, BRAND_POND_5, BRAND_SHUTTERSTOCK, BRAND_TURBO_SQUID, CODE_SEARCH, CODE_SEARCH_URL, DEV, DEVELOPMENT, ERROR_BOUNDARY_LOG_MSG, EVALUATION_FORCED, EVALUATION_NOT_FOUND, EVALUATION_NO_EVALUATIONS, EXPERIMENTS_VIEWED_STASH_KEY, EXPERIMENTS_VIEWED_USER_KEY, EXPERIMENT_VIEWED_EVENT, FORCE_EVALUATIONS_HEADER, HTJS_USER_ID, IS_EXPERIMENT_VISUALIZER_ON, IS_VARIANT_REASON_ALWAYS_SHOWN, IS_VISUALIZER_HOVER_ON, IS_VISUALIZER_TEXT_ON, JIRA_TICKET_REG_EX, LD_FLAG, LOGGED_IN, LOGGED_IN_CHOICES, LOGGED_OUT, NUMERIC_CONTROL, ONLY_SHOW, PROD, PRODUCTION, PRODUCTION_VISUALIZER_ENABLE_KEY, PRODUCTION_VISUALIZER_ENABLE_VALUE, QA, QUERY_PARAM, REASONS, REASON_ERROR, REASON_FALLTHROUGH, REASON_FORCED, REASON_NOT_FOUND, REASON_NO_EVALUATIONS, REASON_OFF, REASON_RULE_MATCH, REASON_TARGET_MATCH, RELATIVE, SESSION_STORAGE_PREFIX, STASH_ITEMS_DELIMETER, VARIANTS, VARIANT_A, VARIANT_B, VARIANT_C, VARIANT_CONTROL, VARIANT_D, VARIANT_E, VARIANT_EXCLUDE, VARIANT_F, VARIANT_G, VARIANT_H, VARIANT_I, VARIANT_J, VARIANT_K, VARIANT_L, VARIANT_M, VARIANT_N, VARIANT_O, VARIANT_P, VARIANT_Q, VARIANT_R, VARIANT_S, VARIANT_T, VARIANT_U, VARIANT_V, VARIANT_W, VISUALIZER_POSITION, WEB_UI, WEB_UI_URL, X_CLIENT_ID, X_END_APP_NAME, X_END_APP_VERSION, X_END_USER_AGENT, X_END_USER_ANONYMOUS_ID, X_END_USER_COUNTRY, X_END_USER_ID, X_END_USER_LOCALE, X_REQUEST_ID, YAML, YAML_URL, emptyArray, emptyObject, noop, stringReturnNoop };
//# sourceMappingURL=index.js.map
